import { render, staticRenderFns } from "./donor-dashboard.vue?vue&type=template&id=50c83db4&"
import script from "./donor-dashboard.vue?vue&type=script&lang=js&"
export * from "./donor-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./donor-dashboard.vue?vue&type=style&index=0&id=50c83db4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports